<p-listbox
  [options]="options"
  [group]="group"
  [scrollHeight]="'calc(100vh - 150px)'"
  [ngModel]="selectedValue"
  [optionLabel]="optionLabel"
  [optionValue]="optionValue"
  (onChange)="onSelectionChange($event?.value)"
  i18n-emptyMessage
  emptyMessage="No results found"
  data-qa="listbox"
>
  <ng-template *ngIf="customGroupTemplate" pTemplate="group" let-group>
    <ng-container *ngTemplateOutlet="customGroupTemplate; context: { $implicit: group }"></ng-container>
  </ng-template>
  <ng-template *ngIf="customItemTemplate" pTemplate="item" let-item>
    <ng-container *ngTemplateOutlet="customItemTemplate; context: { $implicit: item }"></ng-container>
  </ng-template>
</p-listbox>
